var map = {
	"./ar.json": "af08",
	"./ar.min.json": "09db",
	"./en.json": "edd4",
	"./en.min.json": "f32f",
	"./he.json": "ba8d",
	"./he.min.json": "3976",
	"./hr.json": "92d7",
	"./hr.min.json": "e3c2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";